import compose from 'react-hooks-compose'

import { useListaContribuicoesLogic } from './useListaContribuicoes'
import { ListaContribuicoesPresenter } from './presenter'

export const ListaContribuicoes = compose(props => ({
	useLogic: () => useListaContribuicoesLogic(props),
}))(ListaContribuicoesPresenter)
